<div class="page-header-container flex-utility align-center justify-space-between">
  <div class="left-wrapper flex-utility align-center">
    <div class="button-row">
      <ng-container *ngFor="let opt of options">
        <app-horizontal-menu-option *ngIf="isOptionVisible(opt)" [option]="opt" (handler)="optionHandler(opt)">
        </app-horizontal-menu-option>
      </ng-container>
    </div>
  </div>
  <!-- Action button -->
  <app-bulgari-button [ngClass]="{'disabled': buttonDisabled}" (click)="actionHandlerPressed($event)" matRipple
    [type]="buttonStyleType" *ngIf="hasAction" [text]="actionLabel" [disabled]="buttonDisabled"></app-bulgari-button>
  <ng-content></ng-content>
</div>
